import React, { useContext } from 'react';
import './Navigation.scss';
import rightArrow from 'src/assets/svg/arrow_right.svg';
import SVG from 'react-svg';
import { DocumentationContext } from 'src/app/containers/Documentation/Documentation';

const Navigation = () => {
  const data = [
    {
      header: 'Introduction',
      hash: 'intro',
      data: [],
    }, {
      header: 'Getting Started',
      hash: 'started',
      data: [{
        header: 'Prerequisite',
        hash: 'prerequisite',
        data: [],
      }, {
        header: 'Installation',
        hash: 'installation',
        data: [],
      }, {
        header: 'Usage',
        hash: 'usage',
        data: [],
      }],
    }, {
      header: 'Examples',
      hash: 'examples',
      data: [{
        header: 'Assets',
        hash: 'assets',
        data: [{
          header: 'Get Asset',
          hash: 'get-asset',
        }, {
          header: 'Get Assets',
          hash: 'get-assets',
        }, {
          header: 'Create Asset',
          hash: 'create-asset',
        }],
      }, {
        header: 'Events',
        hash: 'events',
        data: [{
          header: 'Get Event',
          hash: 'get-event',
        }, {
          header: 'Get Events',
          hash: 'get-events',
        }, {
          header: 'Create Event',
          hash: 'create-event',
        }, {
          header: 'Parse Events',
          hash: 'parse-event',
        }],
      }, {
        header: 'Bundles',
        hash: 'bundles',
        data: [{
          header: 'Get Bundle',
          hash: 'get-bundle',
        }],
      }, {
        header: 'Transaction',
        hash: 'transaction',
        data: [{
          header: 'Get Transaction',
          hash: 'get-transaction',
        }, {
          header: 'Get Transaction Receipt',
          hash: 'get-transaction-receipt',
        }, {
          header: 'Get-Transaction-Count',
          hash: 'get-transaction-count',
        }, {
          header: 'Send Transaction',
          hash: 'send-transaction',
        }, {
          header: 'Get Balance',
          hash: 'balance',
        }],
      }, {
        header: 'Blocks',
        hash: 'blocks',
        data: [{
          header: 'Get Block',
          hash: 'block',
        }, {
          header: 'Latest Block',
          hash: 'latest-block',
        }],
      }, {
        header: 'Service',
        hash: 'service',
        data: [{
          header: 'Get Account',
          hash: 'block-account',
        }, {
          header: 'Private Key Pair',
          hash: 'pk-pair',
        }, {
          header: 'Encrypt Key',
          hash: 'encrypt-pk',
        }, {
          header: 'Decrypt Key',
          hash: 'decrypt-pk',
        }, {
          header: 'Sign Data',
          hash: 'sign-data',
        }, {
          header: 'Verify Event',
          hash: 'verify-event',
        }, {
          header: 'RPC Validation',
          hash: 'rpc-valid',
        }],
      }],
    },
  ];

  const getClasses = (index1: number, index2: number | null = null, index3: number | null = null): string[] => {
    let className = [];
    if (index2 !== null && index3 !== null && index3 > -1) {
      return [data[index1].data[index2].data[index3].hash];
    } if (index2 !== null) {
      className = [data[index1].data[index2].hash];
      data[index1].data[index2].data.map(values => {
        className.push(values.hash);
      });
      return className;
    }
    className = [data[index1].hash];
    data[index1].data.map(values => {
      if (values.data.length) {
        values.data.map(value => className.push(value.hash));
      }
      className.push(values.hash);
    });
    return className;
  };

  const navList = () => {
    return (
      data.map((data1, index1) => (
        <li key={data1.header + index1} className={isActive(getClasses(index1))}>
          <a onClick={onScroll(65)} href={`#${data1.hash}`}>
            {data1.header}
            {/* {data1.data.length ? (
              <SVG className='arrow-right' wrapper='span' src={rightArrow} />
            ) : ''} */}
          </a>
          {data1.data.length ? (
            <ul className='sub-data'>
              {data1.data.map((data2, index2) => (
                <li key={data2.header + index2} className={isActive(getClasses(index1, index2))}>
                  <a onClick={onScroll(70)} href={`#${data2.hash}`}>
                    {data2.header}
                    {data2.data.length ? (
                      <SVG className='arrow-right' wrapper='span' src={rightArrow} />
                    ) : ''}
                  </a>
                  {data2.data.length ? (
                    <ul className='sub-data'>
                      {data2.data.map((data3, index3) => (
                        <li key={data3.header + index3} className={isActive(getClasses(index1, index2, index3))}>
                          <a onClick={onScroll(70)} href={`#${data3.hash}`}>
                            {data3.header}
                          </a>
                        </li>
                      ))}
                    </ul>
                  ) : ''}
                </li>
              ))}
            </ul>
          ) : ''}
        </li>
      ))
    );
  };

  const context = useContext(DocumentationContext);
  const isActive = (path: string[]) => {
    const checkValue = context.hash ? context.hash : window.location.href.split('#')[1];
    if (path.indexOf(checkValue) > -1) {
      return 'active';
    }
    return '';
  };

  const onScroll = (value: number) => (el: any) => {
    setTimeout(() => {
      window.scrollBy({
        top: -value,
      });
    });
  };

  return (
    <div className='Navigation'>
      <h3>Documentation</h3>
      <ul className='data'>
        {navList()}
      </ul>
    </div>
  );
};

export default Navigation;
